// Utilidad para mostrar notificaciones toast
// Usa notificaciones simples del navegador como fallback

// Función helper para crear toast HTML
function createToast(message, backgroundColor) {
  const toast = document.createElement('div')
  toast.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${backgroundColor};
    color: white;
    padding: 15px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 10000;
    max-width: 350px;
    font-family: system-ui, -apple-system, sans-serif;
    font-size: 14px;
    animation: slideIn 0.3s ease-out;
  `
  toast.textContent = message
  
  // Agregar animación CSS
  if (!document.getElementById('toast-styles')) {
    const style = document.createElement('style')
    style.id = 'toast-styles'
    style.textContent = `
      @keyframes slideIn {
        from { transform: translateX(400px); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOut {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(400px); opacity: 0; }
      }
    `
    document.head.appendChild(style)
  }
  
  document.body.appendChild(toast)
  
  // Auto-remover después de la duración
  setTimeout(() => {
    toast.style.animation = 'slideOut 0.3s ease-in'
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast)
      }
    }, 300)
  }, 3000)
}

export function showSuccessToast(message) {
  createToast(message, '#27ae60')
}

export function showErrorToast(message) {
  createToast(message, '#e74c3c')
}

export function showWarningToast(message) {
  createToast(message, '#f39c12')
}

export function showInfoToast(message) {
  createToast(message, '#3498db')
}
